(function () {
	angular
		.module('trackeye')
		.factory('C4ApiService', C4ApiService);

	C4ApiService.$inject = ['config', 'cacheConfig', '$q', '$http', '$resource', 'CacheFactory', 'HttpQueue', 'NotificationService'];

	function C4ApiService(config, cacheCfg, $q, $http, $resource, CacheFactory, HttpQueue, NotificationService) {

		// @todo move cache initialization to seperate component
		if (!CacheFactory.get('deviceCache')) {
			CacheFactory.createCache('deviceCache', {
				deleteOnExpire: 'passive',
				maxAge: cacheCfg.device.maxAge,
				storageMode: cacheCfg.device.mode
			});
		}

		if (!CacheFactory.get('addressCache')) {
			CacheFactory.createCache('addressCache', {
				deleteOnExpire: 'aggressive',
				maxAge: cacheCfg.address.maxAge,
				storageMode: cacheCfg.address.mode
			});
		}

		if (!CacheFactory.get('tokenCache')) {
			CacheFactory.createCache('tokenCache', {
				deleteOnExpire: 'aggressive',
				maxAge: cacheCfg.token.maxAge,
				storageMode: cacheCfg.token.mode
			});
		}

		if (!CacheFactory.get('modelFeatureCache')) {
			CacheFactory.createCache('modelFeatureCache', {
				deleteOnExpire: 'aggressive',
				maxAge: cacheCfg.modelfeature.maxAge,
				storageMode: cacheCfg.modelfeature.mode
			});
		}

		if (!CacheFactory.get('modelCache')) {
			CacheFactory.createCache('modelCache', {
				deleteOnExpire: 'aggressive',
				maxAge: cacheCfg.model.maxAge,
				storageMode: cacheCfg.model.mode
			});
		}

		if (!CacheFactory.get('configurationsCache')) {
			CacheFactory.createCache('configurationsCache', {
				deleteOnExpire: 'aggressive',
				maxAge: cacheCfg.configurations.maxAge,
				storageMode: cacheCfg.configurations.mode
			});
		}

		var deviceCache = CacheFactory.get('deviceCache'),
			addressCache = CacheFactory.get('addressCache'),
			tokenCache = CacheFactory.get('tokenCache'),
			modelFeatureCache = CacheFactory.get('modelFeatureCache'),
			modelCache = CacheFactory.get('modelCache'),
			configurationsCache = CacheFactory.get('configurationsCache');

		return {
			token: token,
			token_refresh: token_refresh,
			tokenByCode: tokenByCode,
			check: check,
			units: units,
			events: events,
			address: address,
			account: account,
			accountTerms: accountTerms,
			getAccount: getAccount,
			saveAccount: saveAccount,
			configSet: configSet,
			configGet: configGet,
			eventhandler: eventhandler,
			payment_link: payment_link,
			appSubscription: appSubscription,
			deleteConfiguration: deleteConfiguration,
			getConfiguration: getConfiguration,
			saveConfiguration: saveConfiguration,
			putConfiguration: putConfiguration,
			postConfiguration: postConfiguration,
			sutmessages: sutmessages,
			modelfeature: modelfeature,
			modelfeatures: modelfeatures,
			create_account: create_account,
			verify_device: verify_device,
			claim_device: claim_device,
			getInvites: getInvites,
			saveInvite: saveInvite,
			dispatchLog: dispatchLog,
			forward: forward,
			local: local,
			getUrl: getUrl,
			getLocalUrl: getLocalUrl,
			migrationCheck: migrationCheck,
			migrateAccount: migrateAccount,
			triangulate: triangulate,
			rapidmode: rapidmode,
			rapidHistorical: rapidHistorical,
			submitTicket: submitTicket,
			LogINFO: LogINFO,
			LogDEBUG: LogDEBUG
		};

		function migrateAccount(data) {
			return local('POST', 'migrate/account', data);
		}

		function migrationCheck(user, pass) {
			return local('POST', 'migrate/check', {
				user: user,
				pass: pass
			});
		}

		/**
		 *
		 * @param {Invite} invite
		 */
		function saveInvite(invite) {
			var method = invite.isNew ? "POST" : "PUT",
				data = {
					name: invite.name,
					description: invite.description,
					expire: invite.expire,
					links: invite.links
				};

			if (invite.isNew) {
				return local(method, 'invites', data);
			} else {
				return forward(method, invite.href, data);
			}
		}

		function submitTicket(ticket) {
			return local('post', 'ticket', ticket, {}, true);
		}

		function saveConfiguration(id, data, isNew, href) {
			let path = "/configurations"; ///units/9a1d71f0-86aa-4cac-908e-846aed24d4f0
			// Testing if unit id is set, if is set, set the temperature boundary per unit.
			if (typeof data.data.id !== 'undefined') {
				path = "/units/" + data.data.id + path;
			}			
			const method = isNew ? "POST" : "PUT";
			
			if (isNew) {
				path = href ? href + path : path;
			} else {
				path = path + "/" + id;
			}

			return forward(method, path, data);
		}

		function getConfiguration(ident) {
			return forward('GET', '/configurations/' + ident, {}, configurationsCache);
		}

		function deleteConfiguration(id, prefix) {
			return forward('DELETE', prefix + '/configurations' + id);
		}

		function putConfiguration(id, data) {
			return forward('PUT', '/configurations/' + id, data);
		}

		function postConfiguration(data) {
			return forward('POST', '/configurations', data);
		}

		function getInvites(name) {
			var path = name ? "/invites/" + name : "/invites";
			return forward('GET', path)
		}

		function modelfeatures(models) {
			var deferred = $q.defer();
			var features = modelCache.get('modelFeatures') || {};

			var hasKeys = models.every(function(model) {
				return !!features[model];
			});
			if (hasKeys) {
				deferred.resolve(features);
			} else {
				$http({
					url: '/api/device/features',
					method: 'GET',
					params: {
						models: models.join(',')
					}
				}).then(function (response) {
					var features = {}

					feats = response.data || []
					feats.forEach(function(feature) {
						if (models.indexOf(feature.model) >= 0) {
							features[feature.model] = feature
						}
					});
	
					modelCache.put('modelFeatures', features);	
					deferred.resolve(features);

				}, function (response) {
					deferred.reject(response);
				});
			}

			return deferred.promise;
		}

		function modelfeature(model) {
			var deferred = $q.defer();

			if (modelCache.get(model)) {
				deferred.resolve(modelCache.get(model));
			} else {
				$http({
					url: '/api/proxy/flexws/internal/modelfeatures',
					method: 'GET',
					data: {
						format: 'json'
					}
				}).then(function (response) {
					var data = response.data;

					for (var i = 0; i < data.length; i++) {
						if (data[i].model === model) {
							modelCache.put(model, data[i]);
							deferred.resolve(data[i]);
						}
					}
				}, function (response) {
					deferred.reject(response);
				});
			}
			return deferred.promise;
		}

		/**
		 * Request access token
		 *
		 * @param  {string} ident
		 * @param  {string} password
		 * @return {Promise}
		 */
		function token(ident, password, locale) {
			return local('POST', 'oauth2/token', {
				locale: locale,
				username: ident,
				password: password,
				grant_type: "password",
				isAuthenticating: true
			});
		}

		function tokenByCode(code, state, locale) {
			return local('POST', 'oauth2/token/code', {
				locale: locale,
				code: code,
				grant_type: "authorization_code",
				isAuthenticating: true
			});
		}

		/**
		 * Refresh the current access token
		 * @param {string} token
		 * @returns {Promise}
		 */
		function token_refresh(token) {
			return local('POST', 'proxy/oauth2/token', {
				grant_type: "refresh_token",
				refresh_token: token,
				scope: "all",
				isAuthenticating: true
			});
		}

		/**
		 * Create account, and add device
		 *
		 * @param {Object} data
		 * @return {Promise}
		 */
		function create_account(data) {
			return local('POST', 'create/account', data);
		}

		function accountTerms(data) {
			return local('POST', 'account/terms', data);
		}

		function getAccount(ignore_auth) {
			return forward('GET', '/account', {}, undefined, ignore_auth);
		}

		function saveAccount(accountData) {
			return forward('PUT', '/account', accountData);
		}

		function triangulate(nodeid, gsm) {
			return local('POST', 'device/triangulate', {
				nodeid: nodeid,
				gsm: gsm
			},{},true);
		}

		function account() {
			return $resource(getUrl('/account/:directory/:id'), {}, {
				transactions: {
					method: "GET",
					isArray: true,
					params: {
						directory: 'transactions'
					}
				},
				update: {
					method: "PUT",
					isArray: false
				}
			});
		}

		function verify_device(data) {
			return local('POST', 'device/verify', data, {}, true);
		}

		function claim_device(data) {
			return local('POST', 'device/claim', data);
		}

		function payment_link(data) {
			return local('POST', 'payment/link', data);
		}

		function appSubscription(action, data) {
			var api_part = "";
			if (action == "renew") {
				api_part = "renew";
			} else {
				api_part = "start";
			}

			return local('POST', 'app_subscription/' + api_part, data, {}, true);
		}

		/**
		 * Fetch address for given lat/long. Lat/lng, are rounded to
		 * N decimals, for caching purposes.
		 *
		 * @param  {Number} latitude  [description]
		 * @param  {Number} longitude [description]
		 * @param {string} queueId
		 * @return {Promise}
		 */
		function address(latitude, longitude, queueId) {
			// If either lat or lng, is undefined. return an empty promise.
			if (latitude === undefined || longitude === undefined) {
				var deferred = $q.defer();
				deferred.reject();
				return deferred.promise;
			}

			latitude = parseFloat(latitude).toFixed(config.address.decimals);
			longitude = parseFloat(longitude).toFixed(config.address.decimals);

			return HttpQueue.add(queueId, {
				url: getUrl('/address'),
				method: 'POST',
				data: {
					latitude: latitude,
					longitude: longitude
				},
				cache: addressCache,
				__log: false,
				__ignore_errors: true
			}, 5).then(function(data) {
				return data;
			}).catch(function(data) {
				if (data.is50x())
					NotificationService.warning('STR_ERROR_NOTICE_ADDRESS_NOT_RESPONDING');
			});
		}

		function sutmessages() {
			return $resource(getUrl('/units/:id/sutmessages/:last'), {}, {
				get: {
					method: 'GET',
					isArray: true
				},
				last: {
					method: 'GET',
					isArray: true,
					params: {
						last: 'last'
					}
				},
				singleLast: {
					method: 'GET',
					isArray: false,
					params: {
						last: 'last'
					}
				},
				single: {
					url: getUrl('/units/:id/sutmessages/:fsid/:msgid'),
					method: 'GET'
				},
				__log: false
			});
		}

		function rapidHistorical(nodeid, begin, end) {
			return $http({
				method: 'GET',
				url: config.marple.ws+'/RealTimePosDb/webresources/sutmessage',
				params: {
					nodeid: nodeid,
					begin: begin,
					end: end
				},
				__token_injector: false, // ignore the token injector
			});
		}

		function rapidmode(device, duration) {
			var data = new FormData();
			var url = '/sutmessage/configuration';
			var params = [];
			var commands = [{
				cmd: 'RAPIDMODE',
				value: duration
			}];

			if (parseInt(duration,10) > 0) {
				params.push({
					file: 'PAR',
					param: 'RAPIDSERVER-IP',
					value: config.marple.udp,
				});
			}

			data.append('guid', device.getGuid());
			data.append('testform', 1);
			data.append('param', JSON.stringify(params));
			data.append('cmd', JSON.stringify(commands));

			return HttpQueue.add('rapidmode', {
				url: getFlexwsUrl(url),
				method: 'POST',
				headers: {'Content-Type': undefined},
				data: data,
				__log: false,
				__token_injector: false, // ignore the token injector
				__ignore_errors: true
			});
		}

		/**
		 *
		 * @param {string} method
		 * @param {Device} device
		 * @param {FlexEvent} event
		 * @returns {Promise}
		 */
		function eventhandler(method, device, event) {
			/*var url = getUrl('/units/' + device_id + '/flexws/eventhandler'),
				config = {
					method: method,
					data: data
				};

			if (method == "PUT" || method == "DELETE")
				config.params = {uuid: data.uuid};

			config.url = url;*/
			if (method == "PUT" || method == "POST") {
				return local(method, 'eventhandler', {
					device: {
						uuid: device.getUuid(),
						name: device.getName(),
						nodeid: device.getNodeId()
					},
					event: event
				}, false, true);
			} else if (method == "DELETE") {
				var url = '/units/' + device.getUuid() + '/flexws/eventhandler?uuid=' + event.getUuid();
				return forward(method, url);
			}
		}

		function events() {
			return $resource(getUrl('/units/:id/flexws/eventhandler'), {}, {
				get: {
					method: 'GET',
					isArray: true,
					__log: false,
					__ignore_auth: true,
					__ignore_errors: true
				}
			});
		}

		function units() {
			return $resource(getUrl('/units/:id/:directory/:directoryParam'), {}, {
				get: {
					method: 'GET',
					isArray: true
				},
				getOne: {
					method: 'GET',
					isArray: false
				},
				save: {
					method: 'PUT'
				},
				prices: {
					method: 'GET',
					url: '/api/prices'
				},
				appSubscription: {
					method: 'GET',
					url: '/api/app_subscription',
					__ignore_auth: true
				},
				recurringAppSubscription: {
					method: 'POST',
					url: '/api/app_subscription/recurring',
					__ignore_auth: true
				}
			});
		}

		function configSet(data) {
			return local('POST', 'config', data);
		}

		function configGet(data) {
			return local('GET', 'config', data, true, true);
		}


		function Log(type, message, inject_nodeid) {
			return local('POST', 'log', {
				type: type,
				message: message
			}, {
				__log: !!inject_nodeid
			});
		}

		function LogDEBUG(message, inject_nodeid) {
			if (isDebug()) {
				Log('debug', message, inject_nodeid);
			}
		}
		
		function LogINFO(message, inject_nodeid) {
			Log('info', message, inject_nodeid);
		}

		function dispatchLog(data) {
			return local('POST', 'log', data, {__log: false});
		}

		/**
		 *
		 * @param method
		 * @param path
		 * @param data
		 * @param cache
		 * @param {boolean} ignore_auth - Ignore refresh token if 401
		 * @param {boolean} ignore_errors - Ignore xhr error handler
		 * @returns {Promise}
		 */
		function local(method, path, data, merge, ignore_auth, ignore_errors) {
			if (!method)
				return false;

			var httpcfg = {
				method: method,
				url: '/api/' + path,
				__ignore_auth: !!ignore_auth,
				__ignore_errors: !!ignore_errors,
				__log: true
			};

			if (merge) {
				angular.extend(httpcfg, merge);
			}

			if (method.toUpperCase() === "GET") {
				httpcfg.params = data;
			} else {
				httpcfg.data = data;
			}

			return $http(httpcfg);
		}

		/**
		 *
		 * @param method
		 * @param path
		 * @param data
		 * @param cache
		 * @param {boolean} ignore_auth - Ignore refresh token if 401
		 * @param {boolean} ignore_errors - Ignore xhr error handler
		 * @returns {Promise}
		 */
		function forward(method, path, data, cache, ignore_auth, ignore_errors) {
			if (!method)
				return false;

			var httpcfg = {
				method: method,
				cache: cache,
				url: getUrl(path),
				__ignore_auth: !!ignore_auth,
				__ignore_errors: !!ignore_errors
			};

			if (method.toUpperCase() === "GET") {
				httpcfg.params = data;
			} else {
				httpcfg.data = data;
			}

			return $http(httpcfg);
		}

		function check(impersonating) {
			return local('GET','account', {'impersonate': impersonating}, undefined, true, true);
		}

		function getLocalUrl(path) {
			return '/api/'+path;
		}

		function getFlexwsUrl(path) {
			return config.flexws.url + path;
		}

		function getUrl(path) {
			return config.api.url + path;
		}
	}
})();